import { render, staticRenderFns } from "./CustomerFeedback.vue?vue&type=template&id=87d5fe82&scoped=true&"
import script from "./CustomerFeedback.vue?vue&type=script&lang=js&"
export * from "./CustomerFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d5fe82",
  null
  
)

export default component.exports